import {
  ClubBean,
  ClubPropertiesDTOWithRawPhoneNumberCountry,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type CustomerClubApiType = ReturnType<typeof customerClubApi>;

const customerClubApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    findById() {
      return axiosInstance.get<ClubBean>(`${clubPrefix}customer`);
    },

    properties() {
      return axiosInstance.get<ClubPropertiesDTOWithRawPhoneNumberCountry>(
        `${clubPrefix}customer/properties`,
      );
    },
  };
};

export default customerClubApi;
